/**
 * Global configuration for Home Front End
 * @packageDocumentation
 */

interface HomeConfig {
  components: HomeComponentConfig[];
}

/**
 * Component names to map to app sync data in src/components/Shared/helper/mapToComponent.ts
 */
export enum HomeComponents {
  CAREER_RESOURCES = 'CareerResources',
  CAREER_PATHWAYS = 'CareerPathways',
  COACH_CONTACT_CARD = 'CoachContactCard',
  ELIGIBILITY_AND_FINANCE = 'EligibilityAndFinance',
  GENERAL_CONTACT_CARD = 'GeneralContactCard',
  LEARNING_LIFECYCLES = 'LearningLifecycles',
  LEARN_SKILLS = 'LearnSkills',
  RESOURCES = 'Resources',
  STUDENT_LOAN = 'StudentLoanCard',
  YOUR_CLASSES = 'YourClasses',
}

/**
 * Data keys to map components to app sync data
 */
export enum ComponentDataKey {
  CAREER_RESOURCES = 'career_resources',
  CAREER_PATHWAYS = 'career_pathways',
  COACH_CONTACT_CARD = 'coach_contact_card',
  ELIGIBILITY_AND_FINANCE = 'funding',
  GENERAL_CONTACT_CARD = 'general_contact_card',
  LEARNING_LIFECYCLES = 'learning_lifecycles',
  LEARN_SKILLS = 'learn_skills',
  REFERRAL_FORM = 'referral_form',
  RESOURCES = 'resources',
  STUDENT_LOAN = 'student_loan',
  YOUR_CLASSES = 'your_classes',
}

export interface HomeComponentConfig {
  name: HomeComponents;
  dataKey: ComponentDataKey;
}

/**
 * Configuration for mapping React Components to Data Keys from App Sync
 */
export const config: HomeConfig = {
  components: [
    {
      name: HomeComponents.COACH_CONTACT_CARD,
      dataKey: ComponentDataKey.COACH_CONTACT_CARD,
    },
    {
      name: HomeComponents.ELIGIBILITY_AND_FINANCE,
      dataKey: ComponentDataKey.ELIGIBILITY_AND_FINANCE,
    },
    {
      name: HomeComponents.GENERAL_CONTACT_CARD,
      dataKey: ComponentDataKey.GENERAL_CONTACT_CARD,
    },
    {
      name: HomeComponents.LEARN_SKILLS,
      dataKey: ComponentDataKey.LEARN_SKILLS,
    },
    {
      name: HomeComponents.RESOURCES,
      dataKey: ComponentDataKey.RESOURCES,
    },
    {
      name: HomeComponents.STUDENT_LOAN,
      dataKey: ComponentDataKey.STUDENT_LOAN,
    },
    {
      name: HomeComponents.YOUR_CLASSES,
      dataKey: ComponentDataKey.YOUR_CLASSES,
    },
    {
      name: HomeComponents.CAREER_RESOURCES,
      dataKey: ComponentDataKey.CAREER_RESOURCES,
    },
    {
      name: HomeComponents.LEARNING_LIFECYCLES,
      dataKey: ComponentDataKey.LEARNING_LIFECYCLES,
    },
    {
      name: HomeComponents.CAREER_PATHWAYS,
      dataKey: ComponentDataKey.CAREER_PATHWAYS,
    },
  ],
};
